// Select the destination note of each upward diatonic skip (a third or larger).
// Compare successive events in one staff/voice; rests and chords break the line.
export function upwardSkipKeys(notes, measureNumber) {
  const voices = new Map();
  for (const note of notes.filter(
    (n) => n.measureNumber === Number(measureNumber),
  )) {
    const key = `${note.staffIndex}:${note.voiceId}`;
    if (!voices.has(key)) voices.set(key, new Map());
    const events = voices.get(key);
    if (!events.has(note.entryIndex)) events.set(note.entryIndex, []);
    events.get(note.entryIndex).push(note);
  }
  const keys = [];
  for (const events of voices.values()) {
    let previous = null;
    for (const [, group] of [...events].sort((a, b) => a[0] - b[0])) {
      const note =
        group.length === 1 && Number.isFinite(group[0].diatonicPitch)
          ? group[0]
          : null;
      if (note && previous && note.diatonicPitch - previous.diatonicPitch >= 2)
        keys.push(note.selectionKey);
      previous = note;
    }
  }
  return keys;
}
